import React from 'react';
import { Row, Col } from 'bootstrap';
import ModalActions from 'flux/actions/ModalActions';
import EventObjectSearchActions from 'flux/actions/EventObjectSearchActions';
import UIRegions from 'shared/constants/UIRegions';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import EventObjectSearchInput from 'shared/components/event/fsObjectSearchInput';
import EventObjectMoveActions from 'flux/actions/EventObjectMoveActions';
import ConfirmActions from 'flux/actions/ConfirmActions';
import EventFolderListActions from 'flux/actions/EventFolderListActions';
import { DisplayForAdmin } from 'shared/components/misc/displayForRole.jsx';

const tooltipOrientation = 'top';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

/**
 * HOC for generating the header row
 */
export default (showCreateFolderIcon, displayType) => {
  return React.createClass({
    render() {
      const {
        teamId,
        eventId,
        searchInputEnabled,
        selectedItems,
        sortBy,
        sortDirection,
        onTypeSortToggle,
        onNameSortToggle,
        onDateSortToggle,
      } = this.props;

      let fourthHeaderCell = (
        <IconHeaderCell
          {...{ teamId, eventId, showCreateFolderIcon, displayType }}
        />
      );

      if (searchInputEnabled) {
        fourthHeaderCell = <SearchHeaderCell {...{ teamId, eventId }} />;
      } else if (selectedItems && selectedItems.size > 1) {
        fourthHeaderCell = (
          <MultiSelectedIconHeaderCell
            {...{ teamId, eventId, selectedItems }}
          />
        );
      }

      return (
        <Row className="event-list-header">
          {onTypeSortToggle ? (
            <TypeHeaderCell
              sortDirection={sortBy === 'type' ? sortDirection : 'desc'}
              onSortToggle={onTypeSortToggle}
            />
          ) : (
            <SimpleTypeHeaderCell />
          )}
          <NameHeaderCell
            sortDirection={sortBy === 'name' ? sortDirection : 'desc'}
            onSortToggle={onNameSortToggle}
          />
          <DateHeaderCell
            sortDirection={sortBy === 'startOn' ? sortDirection : 'desc'}
            onSortToggle={onDateSortToggle}
          />
          {fourthHeaderCell}
        </Row>
      );
    },
  });
};

const TypeCellProps = {
  lgOffset: 1,
  lg: 2,
  mdOffset: 1,
  md: 3,
  className: 'hidden-sm hidden-xs',
};

/**
 * Type header cell (no sorting)
 */
const SimpleTypeHeaderCell = () => {
  return <Col {...TypeCellProps}>Type</Col>;
};

/**
 * Type header cell
 *
 * @param sortDirection
 * @param onSortToggle
 * @returns {XML}
 * @constructor
 */
export const TypeHeaderCell = ({ sortDirection = 'desc', onSortToggle }) => {
  return (
    <Col {...TypeCellProps}>
      <WithTooltip placement={tooltipOrientation} tip="Sort Type">
        <span>
          <span className="pointer" onClick={onSortToggle}>
            Type&nbsp;
          </span>
          <SortToggle
            sortDirection={sortDirection}
            onSortToggle={onSortToggle}
          />
        </span>
      </WithTooltip>
    </Col>
  );
};

/**
 * Name header cell
 */
export const NameHeaderCell = ({ sortDirection = 'desc', onSortToggle }) => {
  return (
    <Col lg={7} md={8} className="hidden-sm hidden-xs">
      <span>
        <WithTooltip placement={tooltipOrientation} tip="Sort A-Z / Sort Z-A">
          <span>
            <span className="pointer" onClick={onSortToggle}>
              Name&nbsp;
            </span>
            <SortToggle
              sortDirection={sortDirection}
              onSortToggle={onSortToggle}
            />
          </span>
        </WithTooltip>
      </span>
    </Col>
  );
};

/**
 * Date header cell
 */
export const DateHeaderCell = ({
  sortDirection = 'desc',
  onSortToggle,
  label = 'Start Date',
}) => {
  return (
    <Col lg={4} md={4} className="hidden-sm hidden-xs">
      <WithTooltip
        placement={tooltipOrientation}
        tip="Sort in ascending order / Sort in descending order"
      >
        <span>
          <span className="pointer" onClick={onSortToggle}>
            {label}&nbsp;
          </span>
          <SortToggle
            sortDirection={sortDirection}
            onSortToggle={onSortToggle}
          />
        </span>
      </WithTooltip>
    </Col>
  );
};

const SortToggle = ({ sortDirection = 'desc', onSortToggle }) => {
  if (!onSortToggle) return <span />;
  return (
    <span>
      <Icon name={`sort-${sortDirection}`} onClick={onSortToggle} />
      &nbsp;
    </span>
  );
};

/**
 * Search header cell (input)
 */
const SearchHeaderCell = ({ teamId, eventId }) => {
  return (
    <Col lg={10} className="hidden-sm hidden-xs">
      <EventObjectSearchInput {...{ teamId, eventId }} />
    </Col>
  );
};

const MultiSelectedIconHeaderCell = ({ teamId, eventId, selectedItems }) => {
  const numberItemsSelected = selectedItems.size;

  const onDeleteConfirmed = () =>
    EventFolderListActions.archiveObjects(
      teamId,
      eventId,
      selectedItems.map((it) => it.get('_id')),
    );

  const classes =
    'event-list-header-icon-cell hidden-sm hidden-xs event-list-header-multi-icon-cell';

  return (
    <DisplayForAdmin eventId={eventId} teamId={teamId}>
      <Col lg={10} md={7} className={classes}>
        <WithTooltip
          placement={tooltipOrientation}
          delay={0}
          tip={`Move ${numberItemsSelected} items to trash`}
        >
          <span>
            <Icon
              name="trash"
              onClick={() => {
                ConfirmActions.prompt('', onDeleteConfirmed);
              }}
            />
            ({numberItemsSelected})
          </span>
        </WithTooltip>
        &nbsp;
        <WithTooltip
          placement={tooltipOrientation}
          delay={0}
          tip={`Move ${numberItemsSelected} items`}
        >
          <span>
            <Icon
              name="external-link"
              onClick={() => {
                ModalActions.show(UIRegions.EventMoveObjectForm);
                EventObjectMoveActions.populate(selectedItems);
              }}
            />
            ({numberItemsSelected})
          </span>
        </WithTooltip>
        &nbsp;
      </Col>
    </DisplayForAdmin>
  );
};

/**
 * Icon header cell
 */
const IconHeaderCell = ({ teamId, eventId }) => {
  const guestPassIcon = (
    <WithTooltip
      placement={tooltipOrientation}
      delay={0}
      tip="Guest Pass Links"
    >
      <Icon
        name="link"
        onClick={() => ModalActions.show(UIRegions.GuestPass)}
      />
    </WithTooltip>
  );

  return (
    <Col
      lg={10}
      md={7}
      className="hidden-sm hidden-xs event-list-header-icon-cell"
    >
      <DisplayForAdmin eventId={eventId} teamId={teamId}>
        <span>{guestPassIcon}</span>
      </DisplayForAdmin>
      <Icon
        name="search"
        onClick={() => {
          EventObjectSearchActions.toggleVisibility();
        }}
      />
    </Col>
  );
};
